import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateAdvancedUserName = mutatorAction('updateAdvancedUserName', function (username) {
    var store = connectedAccountsStore();
    store.connectAdvancedState.username = username;
});
//# sourceMappingURL=updateAdvancedUserName.js.map